import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { get } from '../apiClient'
import { invoiceAddressSchema } from '../../../common/validations/invoiceAddress'

type Opts = { enabled?: boolean }

const params = (contractUuid: string, enabled = true) => {
  const apiEndpointUrl = API_ENDPOINTS.INVOICE_ADDRESS.replace(
    ':contractUuid',
    contractUuid
  )
  return {
    queryKey: [apiEndpointUrl],
    queryFn: enabled
      ? () => get(apiEndpointUrl, invoiceAddressSchema)
      : async () => null,
  }
}

export const useAPIGetInvoiceAddress = (contractUuid: string, opts?: Opts) =>
  useQuery(params(contractUuid, opts?.enabled ?? true))

export const useAPIGetInvoiceAddressSuspense = (
  contractUuid: string,
  opts?: Opts
) => useSuspenseQuery(params(contractUuid, opts?.enabled ?? true))
